
export type GetStreamingInfoByPath200DrmType = typeof GetStreamingInfoByPath200DrmType[keyof typeof GetStreamingInfoByPath200DrmType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStreamingInfoByPath200DrmType = {
  none: 'none',
  fairplay: 'fairplay',
  widevine: 'widevine',
  playready: 'playready',
} as const;
